module.exports = __webpack_public_path__ + "static/media/work_interest.bde53e18.svg";